"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMedia = void 0;
var SocialMedia;
(function (SocialMedia) {
    SocialMedia["FACEBOOK"] = "facebook";
    SocialMedia["TWITTER"] = "twitter";
    SocialMedia["INSTAGRAM"] = "instagram";
    SocialMedia["YOUTUBE"] = "youtube";
    SocialMedia["PINTEREST"] = "pinterest";
    SocialMedia["LINKEDIN"] = "linkedin";
    SocialMedia["STRAVA"] = "strava";
    SocialMedia["TIKTOK"] = "tiktok";
})(SocialMedia || (exports.SocialMedia = SocialMedia = {}));
//# sourceMappingURL=SocialMediaEnums.js.map